import { render, staticRenderFns } from "./uploadAttachment.vue?vue&type=template&id=f90e7a6a&scoped=true"
import script from "./uploadAttachment.vue?vue&type=script&lang=js"
export * from "./uploadAttachment.vue?vue&type=script&lang=js"
import style0 from "./uploadAttachment.vue?vue&type=style&index=0&id=f90e7a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90e7a6a",
  null
  
)

export default component.exports